/**
 * 原 RegionWrapper 提供了 React 组件式实现，这里提供一个纯 lib 版本
 * 区别是直接在 body 上监听点击事件，通过 dom 元素上的 data- 标识不同 region
 * 注意：点击事件在捕获阶段监听，防止被拦截；但 region 的识别是`冒泡`形式（多个 region 嵌套时，取最靠近 event.target 的）
 */
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

export type OnRegionChange = (regionType: string) => void;

/** data attribute key; e.g. `<div data-region-of-player='note'></div>` */
export const ATTR_REGION_KEY = 'data-region-of-player';
/** key in `element.dataset` */
const REGION_KEY = 'regionOfPlayer';

const getAppServices = (): IEditorAppServices => AppServiceProvider.getInstance().getAppServices() as
    IEditorAppServices;

const getSelectionService = () => getAppServices().viewableServiceLayer?.selectionService;

const validateRegion = (regionType: string) => Object.values(RegionType).includes(regionType);

function setRegion(regionType: string, onRegionChange: OnRegionChange) {
    const type = validateRegion(regionType) ? regionType : RegionType.NONE;

    if (getSelectionService().lastMouseDownRegion === type) {
        console.info('[Regoin] region not change', type);
        return;
    }

    console.info('[Regoin] region change to', type);
    getSelectionService().lastMouseDownRegion = type;

    onRegionChange(type);
}

/**
 * register click event on body
 * @returns unregister function
 */
export function registerRegionDetector(onRegionChange: OnRegionChange): () => void {
    function listener(e: MouseEvent) {
        let targetEle = e.target as HTMLElement;
        while (targetEle) {
            const regionType = targetEle.dataset[REGION_KEY];
            if (regionType) {
                setRegion(regionType, onRegionChange);
                return;
            }

            if (!targetEle.parentElement) break;
            targetEle = targetEle.parentElement;
            if (targetEle === document.body) break;
        }

        setRegion(RegionType.NONE, onRegionChange);
    }

    const eventName = browser.isMobile ? 'touchstart' : 'mousedown';
    document.body.addEventListener(eventName, listener, true);
    return () => document.body.removeEventListener(eventName, listener, true);
}
